export const en = {
    expenses_for_period: 'Expenses',
    preliminary_data: 'The data is preliminary until the end of the period',
    option_year: 'for year',
    option_months_6: 'for 6 months',
    option_months_3: 'for 3 months',
};
